import ThirdPartyNotificationListPage from "./pages/ThirdPartyNotificationListPage";

export const thirdPartyNotificationRoutes = (prefix = "monitorings") => [
  {
    name: "ThirdPartyNotificationListPage",
    path: 'third-party-notification',
    component: ThirdPartyNotificationListPage
  }
];



// WEBPACK FOOTER //
// ./src/features/monitoring/modules/thirdPartyNotification/routes.js